import { Paper } from '@mui/material';
import { RangePlanningItem } from '../types';
import NutritionalDataTab from '../../../components/shared/nutrition/NutritionalDataTab';
import { NutritionSource } from '../../../components/shared/nutrition/types';

interface NutritionTabProps {
  item: RangePlanningItem;
}

/** Reuses the shared NutritionalDataTab component (also used by RecipeV2 and Procurement
 * Products) in read-only mode - this demo screen doesn't support editing nutrition data. */
const NutritionTab = ({ item }: NutritionTabProps) => (
  <Paper variant="outlined"
    sx={{ p: 4 }}>
    <NutritionalDataTab
      nutritionalInfo={item.nutrition}
      onChange={() => { /* read-only in this demo */ }}
      disabled
      source={item.nutrition.source ?? NutritionSource.Supplier}
    />
  </Paper>
);

export default NutritionTab;
